import tradeActivity from './index';
import projectActivity from './project';
import rankActivity from './rank';
import avgCost from './avgCost';
import coinAccount from './coinAccount';
import pairPerson from './pairPersons';
import snapPosition from './snapPosition';
import hedgeManage from './hedgeManage';

import PlateManage from './plate/plateManage.vue';


export default {
    path: '/home/trade/activity',
    component: tradeActivity,
    children: [
        {path: '/home/trade/activity/projects', component: projectActivity},
        {path: '/home/trade/activity/rank', component: rankActivity},
        {path: '/home/trade/avg/cost', component: avgCost},
        {path: '/home/trade/coin/account', component: coinAccount},
        {path: '/home/trade/order/persons', component: pairPerson},
        {path: '/home/trade/snap/position',component: snapPosition},
        {path: '/home/trade/hedge/manage', component: hedgeManage},

        {path: '/home/trade/plate/plateManage', component: PlateManage}
    ]
}
